<ng-container *ngLet="invoice$ | async">
  <div class="h4">
    <a *ngIf="!isDisabled" class="hyperlink" (click)="downloadInvoice(invoiceNumber)" href="javascript:void(0)">Invoice #: {{invoiceNumber}}</a>
    <a *ngIf="isDisabled" class="hyperlink">Invoice #: {{invoiceNumber}}</a>
  </div>
</ng-container>
